var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PSection',{attrs:{"home-news":"","theme":"dark"}},[_c('ul',_vm._l((_vm.list),function(item){return _c('li',{key:item.seq},[_vm._v(_vm._s(item.title))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }